module.exports = __webpack_public_path__ + "img/10.b823f6b9.png";